import { render } from "./button.vue?vue&type=template&id=2f627f82&lang=pug"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f627f82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f627f82', __exports__)) {
    api.reload('2f627f82', __exports__)
  }
  
  module.hot.accept("./button.vue?vue&type=template&id=2f627f82&lang=pug", () => {
    api.rerender('2f627f82', render)
  })

}


export default __exports__